import { css } from '@emotion/css';
import { FaBuilding, FaUserClock } from 'react-icons/fa';

const panelStyle = css`
  position: absolute;
  top: 60px;
  right: 0;
  background-color: white;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0s 0.3s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 1000;
  padding: 20px;

  &.visible {
    opacity: 1;
    visibility: visible;
    transform: translateY(10px);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  
  display: flex;
  justify-content: space-between;
  gap: 20px;

  width: calc(100vw - 40px);
  max-width: 800px;
  margin: 0 auto;

  @media (min-width: 1096px) {
    left: 25%;
    right: auto;
    transform: translate(-50%, 10px);
  }
`;

const columnStyle = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  color: #212A37;
`;

const headerStyle = css`
  font-weight: bold;
  color: #212A37;
  margin-bottom: 12px;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const linkStyle = css`
  display: block;
  margin-bottom: 8px;
  color: #4B5563; 
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s ease;
  &:hover {
    text-decoration: underline;
    color: #e2ba57;
  }
`;

const descriptionStyle = css`
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 16px;
  line-height: 1.4;
`;

const featuredColumnStyle = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #ccc;
  padding-left: 20px;
  color: #212A37;
`;

const featuredTitle = css`
  font-weight: bold;
  margin-bottom: 10px;
`;

const featuredLink = css`
  color: #212A37;
  font-weight: 500;
  display: flex;
  align-items: center;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    color: #e2ba57;
  }
  &::after {
    content: '→';
    margin-left: 5px;
  }
`;

const SolutionsPanel = ({ isVisible }: { isVisible: boolean }) => {
    return (
        <div className={`${panelStyle} ${isVisible ? 'visible' : ''}`}>
            {/* Column 1: For Business */}
            <div className={columnStyle}>
                <div className={headerStyle}>
                    <FaBuilding className="text-[#e2ba57]" />
                    For Business
                </div>
                <a href="/solutions/corporate-audit-shield" className={linkStyle}>
                    Corporate Compliance Solutions
                </a>
                <p className={descriptionStyle}>
                    Establish a dedicated Authorized Representative for your Frisco & DFW remote workforce.
                </p>
            </div>

            {/* Column 2: For Individuals */}
            <div className={columnStyle}>
                <div className={headerStyle}>
                    <FaUserClock className="text-[#e2ba57]" />
                    For Individuals
                </div>
                <a href="/solutions/urgent-i9" className={linkStyle}>
                    Urgent I-9 Verification
                </a>
                <p className={descriptionStyle}>
                    Start date tomorrow? We verify your I-9 in person. No mailing passports.
                </p>
            </div>

            {/* Column 3 (Empty spacer) */}
            <div className={columnStyle}></div>

            {/* Column 4 (Featured/Hook) */}
            <div className={featuredColumnStyle}>
                <div className={featuredTitle}>Risk Assessment</div>
                <div style={{ marginBottom: '10px', fontSize: '14px' }}>
                    Are you sending new hires to shipping centers? You might be liable for a $2,725 fine per error.
                </div>
                <a href="/solutions/corporate-audit-shield" className={featuredLink}>
                    See the Audit Shield Strategy
                </a>
            </div>
        </div>
    );
};

export default SolutionsPanel;